const key = 'userInfo';

export const setSimpleAuth = (userInfo) => {
  sessionStorage.setItem(key, btoa(JSON.stringify(userInfo)));
};

export const getSimpleAuth = () => {
  const encodedValue = sessionStorage.getItem(key);
  if (!encodedValue) return null;

  try {
    const jsonValue = atob(encodedValue);
    return JSON.parse(jsonValue);
  } catch (error) {
    console.error('Decoding error:', error);
    return null;
  }
};

export const clearAuth = () => {
  sessionStorage.clear();
};
